/*
 * Attaches the image uploader to the input field
 */
jQuery(document).ready(function($){

});